module.exports = __webpack_public_path__ + "img/tobahotel.d64f4c17.jpg";